<template>
  <rounded-card show-right-btn height="65%" @set-close-status="$emit('close')">
    <div class="-mt-8 flex flex-col items-center text-center">
      <h3
        class="text-xl font-semibold leading-8 mb-3"
        v-html="$t('mobileScan.device_unsupported')"
      ></h3>
      <h3
        class="my-4 text-sm opacity-50 leading-6 w-2/3"
        v-html="$t('mobileScan.need_faceid')"
      ></h3>
      <img
        class="my-2 -ml-8"
        :src="brandAsset(unsupportedDevice, unsupportedDeviceSanne)"
        :alt="$t('mobileScan.device_unsupported')"
      />
    </div>
  </rounded-card>
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import RoundedCard from '@/components/common/RoundedCard.vue';
import unsupportedDevice from '@/assets/MobileScan/unsupported-device.svg';
import unsupportedDeviceSanne from '@/assets/sanne/oops-device.svg';

export default {
  name: 'UnsupportedDevice',
  mixins: [brandMode],
  components: {
    RoundedCard,
  },
  data: () => ({ unsupportedDevice, unsupportedDeviceSanne }),
};
</script>

<style scoped></style>
